import { render } from "./BaseFooter.vue?vue&type=template&id=be9b6d14&scoped=true"
import script from "./BaseFooter.vue?vue&type=script&lang=js"
export * from "./BaseFooter.vue?vue&type=script&lang=js"

import "./BaseFooter.vue?vue&type=style&index=0&id=be9b6d14&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9b6d14"]])

export default __exports__